<template>
  <div class="page-header-wrapper">
    <h1>{{ $t("bnpl:b2b.kyc.code.title") }}</h1>
    <p>{{ $t("bnpl:b2b.kyc.code.subtitle") }}</p>
  </div>
  <div class="whitebox flex-column align-items-center gap-18 p-3">
    <template v-if="isMobile">
      <div class="flex-column align-items-center gap-18 p-5">
        <div class="spinner-container">
          <IllustrationsSpinnerCircle />
        </div>
        <h3 class="has-text-grey text-center bold m-0 mb-3">
          {{ $t("bnpl:b2b.kyc.waiting.spinner.title") }}
        </h3>
        <button
          class="btn btnL"
          @click="resumeKyc"
        >
          {{ $t("b2b:kyc.resume") }}
        </button>
      </div>
    </template>
    <template v-else>
      <template v-if="url">
        <div class="qrcode-container">
          <QRCode
            :data="url"
            width="1200"
            height="1200"
            :qr-options="{
              typeNumber: 9,
              mode: 'Byte',
              errorCorrectionLevel: 'Q',
            }"
          />
        </div>
        <button
          v-if="showRestart"
          class="btn btnL"
          @click="restartKyc"
        >
          {{ $t("b2b:kyc.restart") }}
        </button>
      </template>
      <template v-else-if="skippable">
        <p>{{ $t('bnpl.kyc.skip_text') }}</p>
        <button
          id="bnpl_kyc_skip_button"
          class="btn btnL"
          @click="emit('skip')"
        >
          {{ $t("bnpl:kyc.skip") }}
        </button>
      </template>
      <!-- Without a URL and without a skip there is nothing to do but try again, so offer that
           rather than a button that cannot act. -->
      <template v-else>
        <p>{{ $t("bnpl:intro_kyc.no_url") }}</p>
        <button
          id="bnpl_kyc_retry_button"
          class="btn btnL"
          @click="restartKyc"
        >
          {{ $t("b2b:kyc.restart") }}
        </button>
      </template>
    </template>
  </div>
</template>

<script setup>
import { useKycStore } from '~~/stores/kyc';
import platform from 'platform';

const emit = defineEmits(['skip'])

defineProps({
  /** False for the intro KYC gate, where skipping would strand the customer on the data check. */
  skippable: {
    type: Boolean,
    default: true,
  },
})

const kycStore = useKycStore();

const url = computed(() => kycStore.url);

const isMobile = computed(() => {
  if (['Android', 'iOS', 'Windows Phone'].includes(platform.os.family)) {
    return true;
  }
  return false;
});

const showRestart = ref(false);

function restartKyc() {
  kycStore.startIdentification(kycStore.reference);
  showRestart.value = false;
  setTimeout(() => {
    showRestart.value = true;
  }, 60000)
}

function resumeKyc() {
  window.location.assign(kycStore.url);
}

function redirectToKyc() {
  window.location.replace(url.value);
}

onMounted(async () => {
  kycStore.kyc.status = KYC_STATUS.CREATED;
  if (!url.value) {
    await kycStore.startIdentification(kycStore.reference);
  }
  if (isMobile.value) {
    window.location = url.value;
  }
  setTimeout(() => {
    showRestart.value = true;
  }, 60000)
});

</script>

<style>
.qrcode-container {
  align-self: center;
  width: 400px;
  height: 400px;
}
</style>